export default __webpack_public_path__ + "static/media/monkey14.f6e812cd.jpeg";